export default __webpack_public_path__ + "static/media/client1.9fc6f70d.jpg";